import { computed, makeObservable, observable } from 'mobx';

class CurrentUrl {
  constructor() {
    this.value = new URL(window.location.href);
    makeObservable(this);
    window.addEventListener('popstate', () => {
      this.value = new URL(window.location.href);
    });
    window.addEventListener('hashchange', () => {
      this.value = new URL(window.location.href);
    });
    window.history.pushState = new Proxy(window.history.pushState, {
      apply: (target, thisArg, args) => {
        target.apply(thisArg, args as any);
        this.value = new URL(window.location.href);
      },
    });
    window.history.replaceState = new Proxy(window.history.replaceState, {
      apply: (target, thisArg, args) => {
        target.apply(thisArg, args as any);
        this.value = new URL(window.location.href);
      },
    });
  }

  @observable private value: URL;

  @computed
  get pathname(): string {
    return this.value.pathname;
  }

  @computed
  get search(): string {
    return this.value.search;
  }

  @computed
  get searchParams(): URLSearchParams {
    // construct a new object from `this.value.search`, so that
    // mobx only changes when `search` changes (not anything in `value`)
    return new URLSearchParams(this.value.search);
  }
}

export const currentUrl = new CurrentUrl();
